import { apiCallStatus } from 'helpers/constants';
import { actionTypes } from './constants';

const initialRebootGatewayState = {
    loadingStatus: null,
    data: null,
    error: null
};

export function RebootGatewayReducer(state = initialRebootGatewayState, action) {
    switch (action.type) {
        case actionTypes.REBOOT_GATEWAY_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    data: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    data: null,
                    error: action.error
                };
            }
            break;
        case actionTypes.CLEAR_STORE:
            return {
                ...initialRebootGatewayState
            };
        default:
            return state;
    }
}
